'use memo'

import React from 'react'
import { IdcardOutlined } from '@ant-design/icons'
import { ScrollSpyLayout } from 'src/components/ScrollSpyLayout'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import { TextField, FieldRow } from '../FormikField'

const MembershipSection: React.FC = () => (
  <ScrollSpyLayout.Section
    id='membership'
    title={capitalizeWords('Membership')}
    icon={<IdcardOutlined />}
  >
    <FieldRow>
      <TextField
        name='leagueRegistrationNumber'
        label='League Registration Number'
        placeholder={capitalizeWords('Registration number')}
      />
      <TextField
        name='hockeyUsaNumber'
        label='USA Hockey Number'
        placeholder={capitalizeWords('USA Hockey number')}
      />
    </FieldRow>
    <FieldRow>
      <TextField
        name='hockeyCanadaNumber'
        label='Hockey Canada Number'
        placeholder={capitalizeWords('Hockey Canada number')}
      />
      <TextField
        name='customMembershipNumber'
        label='Custom Membership Number'
        placeholder={capitalizeWords('Membership number')}
      />
    </FieldRow>
    <FieldRow>
      <TextField
        name='loyaltyNumber'
        label='Loyalty Number'
        placeholder={capitalizeWords('Loyalty number')}
      />
    </FieldRow>
  </ScrollSpyLayout.Section>
)

export default MembershipSection
